import { i18n } from '@fs/zion-locale'

/**
 * Enum for referrer types used in the Add Name Panel.
 * @readonly
 * @enum {string}
 * @property {string} ATTACH_TO_TREE - Referrer for attaching to a tree.
 * @property {string} BLANK_STATE - Referrer for blank state.
 * @property {string} MANAGE_NAMES - Referrer for managing names.
 */
export const ADD_NAME_PANEL_REFERRERS = {
  ATTACH_TO_TREE: 'attachToTree',
  BLANK_STATE: 'blankState',
  MANAGE_NAMES: 'manageNames',
}

/**
 * Returns header details (title, subtitle, heading color) based on the provided referrer.
 *
 * @param {string} referrer - The source or context from which the add names panel is opened. Should be one of the values in ADD_NAME_PANEL_REFERRERS.
 * @returns {{title: string, subtitle: (string|null), headingColor: string}} An object containing the localized title, subtitle, and heading color for the panel header.
 */
export const getHeaderDetails = (referrer) => {
  switch (referrer) {
    case ADD_NAME_PANEL_REFERRERS.ATTACH_TO_TREE:
      return {
        title: i18n.t('fullText.addNamesPanel.attachToTree.title', 'Attach to Family Tree'),
        subtitle: i18n.t('fullText.addNamesPanel.attachToTree.subtitle', 'Add name'),
        headingColor: 'green',
      }
    case ADD_NAME_PANEL_REFERRERS.MANAGE_NAMES:
      return {
        title: i18n.t('fullText.addNamesPanel.manageNames.title', 'Manage Names'),
        subtitle: i18n.t('fullText.addNamesPanel.manageNames.subtitle', 'Add name'),
        headingColor: 'yellow',
      }
    case ADD_NAME_PANEL_REFERRERS.BLANK_STATE:
    default:
      return {
        title: i18n.t('fullText.addNamesPanel.blankState.title', 'Add Names'),
        subtitle: null,
        headingColor: 'yellow',
      }
  }
}

/**
 * Redirects the user to the Source Linker page for a given person ARK identifier.
 * Opens the Source Linker in a new browser tab if possible, otherwise navigates in the current tab.
 *
 * @param {string} personArk - The ARK identifier of the person to link sources for.
 */
export const redirectToSourceLinker = (personArk) => {
  const arkPath = `/ark:/61903/${personArk}`
  const sourceLinkerUrl = `/search/linker?ark=${encodeURIComponent(arkPath)}&sourceType=rii`
  window.open(sourceLinkerUrl, '_blank') || window.location.assign(sourceLinkerUrl)
}
